// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6378) return "static/css/6378.7a7179286a0ad240fda9.css";
	if (chunkId === 1488) return "static/css/receiver.d2fa50e600c8902170ab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1412":"4f767f2564a62b1968c8","1474":"201f07b8e64160d7069f","6454":"201f07b8e64160d7069f","8285":"201f07b8e64160d7069f","9561":"201f07b8e64160d7069f"}[chunkId] + ".chunk.css";
};